/**
 * Canonical single-line address for an inspection for display.
 * Prefer `property.address` (structured / recorder); fall back to legacy `inspection.address`.
 * Accepts `unknown` so calendar/event payloads and loosely typed API shapes work without casts.
 */
export function getInspectionDisplayAddress(inspection: unknown): string {
  if (inspection == null || typeof inspection !== 'object') return '';
  const i = inspection as {
    property?: { address?: string | null } | null;
    address?: string | null;
  };
  const fromProperty = i.property?.address?.trim();
  if (fromProperty) return fromProperty;
  return (i.address ?? '').trim();
}
